import React from 'react';
import './style.scss';

/**
 * Different props affect the display properties of the loader
 *    * dark: inverts default colors from white to gray
 *    * noCenter: removed flex-box centering so that it can be used as an inline-element for butotns
 *    * inline: should probably be coupled with `noCenter`, but allows the loader to be used inline with buttons and such
 *    * text: adds "Loading" text below an `inline` loader
 *    * fill: does a flex-box centering fill
 */
const defaultProps = {
  dark: false,
  noCenter: true,
  inline: false,
  text: false
};

class Loader extends React.Component {

  render() {

    const { dark, center, inline, text, fill } = this.props;

    const darkClass = this.props.dark ? "dark" : "";
    const centerClass = this.props.noCenter ? "" : "abs-center";

    return (
      <div className={`brainLoader-wrapper ${inline ? 'inline' : ''} ${fill ? 'fill' : ''} ${darkClass}`} {..._.omit(this.props, ['dark', 'noCenter', 'inline', 'text', 'fill'])}>
        <div className={`brainLoader ${centerClass}`}></div>
        {
          text ? <span>Loading</span> : null
        }
      </div>
    );

  }

}

Loader.defaultProps = defaultProps;

export default Loader;
